(function () {
  function init() {
    // Works whether it’s .menu-drawer, .drawer, or dialog
    const root = document.querySelector('.menu-drawer, .drawer, dialog');
    if (!root) return;

    const allDetails = Array.from(root.querySelectorAll('details'));

    allDetails.forEach(d => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;

        // Close siblings on same level
        const parent = d.parentElement;
        const siblings = Array.from(parent.querySelectorAll(':scope > details'));
        siblings.forEach(s => {
          if (s !== d) s.removeAttribute('open');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
